import HeaderComponent from "@/app/components/ui/Header/index";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { IRotaState, setRotaerrorIds, setSelectedStafForCopy } from "@/app_redux/reducers/slices/auth/rota_slice";
import { useEffect } from "react";

const RotaErrorListComponent = () => {
  const { getRouteKey } = useRouter();
  const dispatch = useAppDispatch();
  const routeId = getRouteKey("ROTA", "id");
  const { routeState } = useRouteInfo(routeId);
  const { rotaErrorList } = routeState.state as IRotaState;

  useEffect(() => {
    dispatch(setSelectedStafForCopy(null));
    dispatch(setRotaerrorIds({ data: null }));
  }, []);

  return (
    <>
      <HeaderComponent title={rotaErrorList?.header} />
      <div className="mt-5">
        <div>
          <table className="w-full">
            <tr>
              <th className="text-sm font-medium w-2/12 text-left p-5">Provider Name</th>
              <th className="text-sm font-medium w-2/12 text-left p-5">Provider Category</th>
              <th className="text-sm font-medium w-1/12 text-left p-5">Date</th>
              <th className="text-sm font-medium w-2/12 text-left p-5">Existing Clinic</th>
              <th className="text-sm font-medium w-1/12 text-left p-5">Shift Name</th>
              <th className="text-sm font-medium w-2/12 text-left p-5">Timing</th>
            </tr>
            <tbody>
              {rotaErrorList?.errors?.map((value, id) => {
                return (
                  <tr key={id}>
                    <td className="text-xs text-left p-5">{value?.provider_name}</td>
                    <td className="text-xs text-left p-5 ">{value?.provider_category}</td>
                    <td className="text-xs text-left p-5">{value?.date}</td>
                    <td className="text-xs text-left p-5">{value?.existing_clinic}</td>
                    <td className="text-xs text-left p-5">{value?.shift_name}</td>
                    <td className="text-xs text-left p-5">{value?.timing}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};
export default RotaErrorListComponent;
